import * as moment from 'moment';
import {
  BaseFederalExemptionType,
  BaseProvincialExemptionType,
  CustomCode,
  DayType,
  DBStatus,
  Employee,
  HiringStatus,
  HiringType,
  HolidayCalculationType,
  HoraireRoundingMode,
  JobAndUnitInfo, JobInfo,
  JobStatusType,
  PaymentModeType,
  PreferenceAppel,
  ProvinceCode,
  ProvinceStateCode,
  ReasonType,
  ScheduleStatus,
  Unit,
  UsableWageType,
  User,
  WorkCodeData
} from './common.model';
import {JSonSerializer} from './JSonSerializer';
import {DisplayInterval} from '../directives/displayInterval';
import {EmployeeJob} from "./EmployeeJob";
import {EmployeeAvailabilitySpecial} from "../home/memo/model/EmployeAvailabilitySpecial";
import {ApprovalState} from "../home/memo/model/ApprovalState";
import {EmployeeNote, NoteVisibility} from "../home/employee/model/EmployeeNote";

import {TranslateService} from "@ngx-translate/core";
import {Utils} from "./Utils";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {MealDurationType} from "./MealDurationType";
import {CCQConfigurationForEmployee} from "./CCQConfigurationForEmployee";
import {SecurityPerUser} from "../home/security/model/SecurityPerUser";
import {SecurityPerEnterprise} from "../home/security/model/SecurityPerEnterprise";
import {UsagerBudget} from "../home/employee/model/UsagerBudget";
import {BankTypeEmployee} from "../home/bank/model/BankTypeEmployee";
import {PrefName, PrefType, UserPreference} from "./Preferences";
import {CustomPremiumConfigurationForEmployee} from "../home/bonus/model/CustomPremiumConfigurationForEmployee";
import {Enterprise} from "./Enterprise";
import {EnterpriseCostDistributionConfig} from "../home/costDistribution/model/EnterpriseCostDistributionConfig";
import {NotificationData} from "../halfGod/model/NotificationData";
import {EmployeeGroup} from "../home/group/model/EmployeeGroupAggregation";
import {EmployeeNotificationConfiguration} from "./EmployeeNotificationConfiguration";
import {EmployeeFamilyDays} from "./EmployeeFamilyDays";
import {CumulativeBonusIdInterface} from "./bonus/CumulativeBonusIdInterface";
import {JobBonusAndCumulativeBonusHelper} from "./bonus/JobBonusAndCumulativeBonusHelper";

export class SearchResultEmployeeAggregation {
  employee = new Employee();
  matricule: string;
  user = new User();
  active: boolean;
  terminated: boolean;
}


export class DashboardEmployeeAggregation {
  employee = new Employee();
  matricule: string;
  user = new User();
  wage: number;
  nbJobs: number;
  timeBankInMin: number;
  usedSickDays: number;
  sickDaysLeft: number;
  vacationLeft: number;
  vacationAmountLeft: number;
  defaultJob = new EmployeeJob();
  defaultJobBonus =  new Array<JobBonus>();
  contacts = new Array<EmployeeContact>();
  bonus = new Array<CumulativeBonus>();
  punchParams = new EmployeePunchParams();
  prefAppel = new EmployeePrefAppel();
  lastHiringDetail = new HiringDetail();
  exportedToPay = false;
  availability = new EmployeeAvailability();
  availabilityDetails = new Array<EmployeeAvailabilityDetail>();
  availabilitySpecials = new Array<EmployeeAvailabilitySpecial>();
  documents = new Array<EmployeeDocument>();
  lastVisibleNote = new EmployeeNote();
  enterprise = new Enterprise();
  fullCalendarUrl: string; // Contains http://.xxxx.ics
  nbSkills:number;
  nbExpiredSkills:number;
  nbActiveSkills:number;
  dayOfWeekStart: DayType;
  ccqConfigurationForEmployee = new CCQConfigurationForEmployee();
  usagerBudget = new UsagerBudget();

  vacationLeftInMinutes: number;
  employeeProfileImg64: string;

  securityPerEnterprise = new SecurityPerEnterprise();


  bankTypesForEmployee = new Array<BankTypeEmployee>();
  notifications = new Array<NotificationData>();

  groups = new Array<EmployeeGroup>();

  familyDays = new Array<EmployeeFamilyDays>()


  _createSpecialElement(propertyName: string, data: any) {
    if ('dayOfWeekStart' === propertyName) {
      this.dayOfWeekStart = DayType.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('defaultJobBonus' === propertyName) {
      for (const bean of <JobBonus[]> data) {
        const tmp = new JobBonus();
        serializer.deserialize(bean, tmp);
        this.defaultJobBonus.push(tmp);
      }
    }
    if ('contacts' === propertyName) {
      for (const bean of <EmployeeContact[]> data) {
        const tmp = new EmployeeContact();
        serializer.deserialize(bean, tmp);
        this.contacts.push(tmp);
      }
    }
    if ('bonus' === propertyName) {
      for (const bean of <CumulativeBonus[]> data) {
        const tmp = new CumulativeBonus();
        serializer.deserialize(bean, tmp);
        this.bonus.push(tmp);
      }
    }
    if ('availabilityDetails' === propertyName) {
      for (const bean of <EmployeeAvailabilityDetail[]> data) {
        const tmp = new EmployeeAvailabilityDetail();
        serializer.deserialize(bean, tmp);
        this.availabilityDetails.push(tmp);
      }
    }
    if ('availabilitySpecials' === propertyName) {
      for (const bean of <EmployeeAvailabilitySpecial[]> data) {
        const tmp = new EmployeeAvailabilitySpecial();
        serializer.deserialize(bean, tmp);
        this.availabilitySpecials.push(tmp);
      }
    }
    if ('documents' === propertyName) {
      for (const bean of <EmployeeDocument[]> data) {
        const tmp = new EmployeeDocument();
        serializer.deserialize(bean, tmp);
        this.documents.push(tmp);
      }
    }

    if ('bankTypesForEmployee' === propertyName) {
      for (const bean of <BankTypeEmployee[]> data) {
        const tmp = new BankTypeEmployee();
        serializer.deserialize(bean, tmp);
        this.bankTypesForEmployee.push(tmp);
      }
    }

    if ('notifications' === propertyName) {
      for (const bean of <NotificationData[]> data) {
        const tmp = new NotificationData();
        serializer.deserialize(bean, tmp);
        this.notifications.push(tmp);
      }
    }


    if ('groups' === propertyName) {
      for (const bean of <EmployeeGroup[]> data) {
        const tmp = new EmployeeGroup();
        serializer.deserialize(bean, tmp);
        this.groups.push(tmp);
      }
    }

    if ('familyDays' === propertyName) {
      for (const bean of <EmployeeFamilyDays[]> data) {
        const tmp = new EmployeeFamilyDays();
        serializer.deserialize(bean, tmp);
        this.familyDays.push(tmp);
      }
    }




  }


  public isEmployeeActive(): boolean{
      let res = false;
      if (!Utils.isNullOrUndefined(this.lastHiringDetail)){
        if (this.lastHiringDetail.type.isEmployeeActive()){
          res = true;
          // Now checking the date.
          if (!Utils.isNullOrUndefined(this.lastHiringDetail.eventDt)){
            if (!Utils.isToday(this.lastHiringDetail.eventDt)){
              if (Utils.isAfterToday(this.lastHiringDetail.eventDt)){
                  res = false;
              }
            }
          }

        }
      }
      // console.log('Employee is not active.');
      return res;
  }

  public isEmployeeCCQ(): boolean{
    let res = false;
    if (!Utils.isNullOrUndefined(this.ccqConfigurationForEmployee)){
      res = this.ccqConfigurationForEmployee.active;
    }
    return res;
  }

}

/*
public class EmployeAvailabilityAndDetails {

  @Expose
  @SerializedName("availability")
  private EmployeAvailability m_employeAvailability;

  @Expose
  @SerializedName("availabilityDetail")
  private List<EmployeAvailabilityDetail> m_employeAvailabilityDetailList = new ArrayList<EmployeAvailabilityDetail>();
*/

export class EmployeeDocument {
  id: number = -1*moment().valueOf();
  employeeId: string;
  entityCode: string;
  mimeType: string;
  origFileName: string;
  relativeFileLocation: string;
  note: string;
  userName: string;
  userFullName: string;
  eventDate: Date;
  visibleByTheEmployee = false;
  sizeInByte: number;

  perm = DocumentVisibility.ALL;

  firstname: string = null;
  lastname: string = null;


  _createSpecialElement(propertyName: string, data: any) {
    if ('perm' === propertyName) {
      this.perm = DocumentVisibility.retrieveFromCode(data);
      return true;
    }
    return false;
  }

}


export class DocumentVisibility extends CustomCode{
  public static _registered = new Map<string, DocumentVisibility>();

  static ALL = new DocumentVisibility('ALL');
  static ADMIN = new DocumentVisibility('ADMIN');
  static PRIVATE = new DocumentVisibility('PRIVATE');

  static LIST = Array.from(DocumentVisibility._registered.values());

  constructor(code: string) {
    super(code);
    DocumentVisibility._registered.set(code, this);
  }


  static retrieveFromCode(code: string): NoteVisibility {
    const res = DocumentVisibility._registered.get(code);
    if (!res) {
      console.log('DocumentVisibility can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  public toTranslateKey(): string{
    return 'DOCUMENT_VISIBILITY_' + this.code;
  }


}


export class EmployeeAvailabilityAggregation {
  periodicAvailabilities = new Array<EmployeeAvailabilityAndDetails>();
  specialEvents = new Array<EmployeeAvailabilitySpecial>();

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('periodicAvailabilities' === propertyName) {
      for (const bean of <EmployeeAvailabilityAndDetails[]> data) {
        const tmp = new EmployeeAvailabilityAndDetails();
        serializer.deserialize(bean, tmp);
        this.periodicAvailabilities.push(tmp);
      }
    }

    if ('specialEvents' === propertyName) {
      for (const bean of <EmployeeAvailabilitySpecial[]> data) {
        const tmp = new EmployeeAvailabilitySpecial();
        serializer.deserialize(bean, tmp);
        this.specialEvents.push(tmp);
      }
    }
  }

}

export class EmployeeAvailabilityAndDetails {
  availability = new EmployeeAvailability();
  availabilityDetail = new Array<EmployeeAvailabilityDetail>();
  noteFromApprover: string;
  memoId: number;

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('availabilityDetail' === propertyName) {
      for (const bean of <EmployeeAvailabilityDetail[]> data) {
        const tmp = new EmployeeAvailabilityDetail();
        serializer.deserialize(bean, tmp);
        this.availabilityDetail.push(tmp);
      }
    }
  }


  prepareIntervalForHuman(di: DisplayInterval){
    for (const b of this.availabilityDetail){
      b.prepareIntervalForHuman(di);
    }
  }


}

export class EmployeeAvailability {

  id: number;
  employeeCode: string;
  activeStartingDate: Date;
  note: string;
  state: ApprovalState;

  _createSpecialElement(propertyName: string, data: any) {
    if ('state' === propertyName) {
      this.state = ApprovalState.retrieveFromCode(data);
      return true;
    }
    return false;
  }
}

export class EmployeeAvailabilityDetail {
  id: number;
  availabilityId: number;
  dayType: DayType;
  // interval: number; // Deprecated
  note: string;
  intervalForHuman: string;
  startHour : Date;
  endHour: Date;



  _createSpecialElement(propertyName: string, data: any) {
    if ('dayType' === propertyName) {
      this.dayType = DayType.retrieveFromCode(data);
      return true;
    }
    return false;
  }

  clone(): EmployeeAvailabilityDetail{
    const res = new EmployeeAvailabilityDetail();
    res.id = -1 * moment().unix();
    res.availabilityId = this.availabilityId;
    res.dayType = this.dayType;
    res.note = this.note;
    // res.interval = this.interval;
    res.startHour = this.startHour;
    res.endHour = this.endHour;
    res.intervalForHuman = this.intervalForHuman;
    return res;
  }

  prepareIntervalForHuman(di: DisplayInterval){
    this.intervalForHuman = di.displayDates(this.startHour,this.endHour,di.formatAMPM,true);
  }


  static sort(lst: EmployeeAvailabilityDetail[], startOfWeek: DayType): EmployeeAvailabilityDetail[]{
    lst.sort((e1: EmployeeAvailabilityDetail, e2: EmployeeAvailabilityDetail)  => {
                           let resN = 0;
                           const l1 = e1.dayType.orderWhenWeekStartOn(startOfWeek);
                           const l2 = e2.dayType.orderWhenWeekStartOn(startOfWeek);

                           if (l1 < l2){
                             resN = 1;
                           }else{
                             resN = -1;
                           }
                           if (l1 === l2){
                             resN = 0;
                             if (Utils.isBeforeRefDate(e1.startHour,e2.startHour)){
                               resN = 1;
                             }else{
                               resN = -1;
                             }
                             // if (e1.interval < e2.interval){
                             //   resN = - 1;
                             // }
                             // if (e1.interval > e2.interval){
                             //   resN = +1;
                             // }
                           }
                           return resN;
    });
    return lst;
  }

}


export class HiringAggregation {
  employeeId: string;
  hiring = new Hiring();
  details = new Array<HiringDetail>();

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('details' === propertyName) {
      for (const bean of <HiringDetail[]> data) {
        const tmp = new HiringDetail();
        serializer.deserialize(bean, tmp);
        this.details.push(tmp);
      }
    }
  }

  get isTerminated(){
    /**
     * details are already sorted.
     */
    if (this.details.length>0){
      const hiringDetail = this.details[this.details.length-1];
      if (HiringType.DEPART === hiringDetail.type){
        // if ((Utils.isBeforeToday(hiringDetail.eventDt) || Utils.isToday(hiringDetail.eventDt))){
          return true;
        //}
      }
    }

    return false;
  }


}


export class Hiring {
  employeeId: string;
  matricule: string;
  hiringStatus: HiringStatus;
  scheduleStatus: ScheduleStatus;
  seniorityDate: Date;
  weeklyHoursMin: number;
  weeklyHoursMax: number;

  _createSpecialElement(propertyName: string, data: any) {
    if ('hiringStatus' === propertyName) {
      this.hiringStatus = HiringStatus.retrieveFromCode(data);
      return true;
    }
    if ('scheduleStatus' === propertyName) {
      this.scheduleStatus = ScheduleStatus.retrieveFromCode(data);
      return true;
    }
    return false;
  }


}

export class HiringDetail {

  employeeId: string;
  eventDt: Date;
  type: HiringType;
  reason: ReasonType;
  note: string;
  lastChangeDt: Date;
  changedByCode: string;
  changedByFullName: string;
  backToWorkDt:Date;
  endOfContractDt:Date;


  _createSpecialElement(propertyName: string, data: any) {
    if ('type' === propertyName) {
      this.type = HiringType.retrieveFromCode(data);
      return true;
    }
    if ('reason' === propertyName) {
      this.reason = ReasonType.retrieveFromCode(data);
      return true;
    }
    return false;
  }
}



export class JobBonus {
  id: number;
  isDefault: boolean;
  name: string;
  mon = DBStatus.INACTIVE;
  tue = DBStatus.INACTIVE;
  wed = DBStatus.INACTIVE;
  thu = DBStatus.INACTIVE;
  fri = DBStatus.INACTIVE;
  sat = DBStatus.INACTIVE;
  sun = DBStatus.INACTIVE;
  startTime: Date;
  endTime: Date;
  percent: number;
  hour: number;
  exportHour: string;
  exportBonus: string;
  divisions: string;

  activeFrom:Date;
  activeTo: Date;

  isEveryDay():boolean{
    if (!Utils.isNullOrUndefined(this.mon)){
      if (DBStatus.ACTIVE !== this.mon){
        return false;
      }
    }else{
      return false;
    }
    if (!Utils.isNullOrUndefined(this.tue)){
      if (DBStatus.ACTIVE !== this.tue){
        return false;
      }
    }else{
      return false;
    }
    if (!Utils.isNullOrUndefined(this.wed)){
      if (DBStatus.ACTIVE !== this.wed){
        return false;
      }
    }else{
      return false;
    }
    if (!Utils.isNullOrUndefined(this.thu)){
      if (DBStatus.ACTIVE !== this.thu){
        return false;
      }
    }else{
      return false;
    }
    if (!Utils.isNullOrUndefined(this.fri)){
      if (DBStatus.ACTIVE !== this.fri){
        return false;
      }
    }else{
      return false;
    }
    if (!Utils.isNullOrUndefined(this.sat)){
      if (DBStatus.ACTIVE !== this.sat){
        return false;
      }
    }else{
      return false;
    }
    if (!Utils.isNullOrUndefined(this.sun)){
      if (DBStatus.ACTIVE !== this.sun){
        return false;
      }
    }else{
      return false;
    }
    return true;
  }


  containsUnitCode(code: string):boolean{
    if (Utils.isNullOrUndefined(this.divisions)){
      return false;
    }
    if (this.divisions.indexOf(code)>=0){
      return true;
    }
    return false;
  }


  listOfDays(translate:TranslateService):string{
    let res = '';
    if (!Utils.isNullOrUndefined(this.mon)) {
      if (this.mon.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('Monday');
      }
    }
    if (!Utils.isNullOrUndefined(this.tue)) {
      if (this.tue.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('Tuesday');
      }
    }
    if (!Utils.isNullOrUndefined(this.wed)) {
      if (this.wed.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('Wednesday');
      }
    }
    if (!Utils.isNullOrUndefined(this.thu)) {
      if (this.thu.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('Thursday');
      }
    }
    if (!Utils.isNullOrUndefined(this.fri)) {
      if (this.fri.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('Friday');
      }
    }
    if (!Utils.isNullOrUndefined(this.sat)) {
      if (this.sat.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('Saturday');
      }
    }
    if (!Utils.isNullOrUndefined(this.sun)) {
      if (this.sun.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('Sunday');
      }
    }
    return res;
  }

  _createSpecialElement(propertyName: string, data: any) {
    if ('mon' === propertyName) {
      this.mon = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('tue' === propertyName) {
      this.tue = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('wed' === propertyName) {
      this.wed = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('thu' === propertyName) {
      this.thu = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('fri' === propertyName) {
      this.fri = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('sat' === propertyName) {
      this.sat = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('sun' === propertyName) {
      this.sun = DBStatus.retrieveFromCode(data);
      return true;
    }
    return false;
  }


}

export class EmployeeContact {
  id: string;
  contactType: string;
  lname: string;
  fname: string;
  homePhone: string;
  officePhone: string;
  cellPhone: string;
  rowIndex: number;
  email: string;
  note: string;
}

export class Remuneration {
  employeeId: string;
  startSalary: number;
}

export class RemunerationDetail {
  employeeId: string;
  adjustingDt: Date;
  adjustment: number;
  doneByCode: string;
  nextAdjustingDt: Date;
  note: string;
  adjustmentFullName: string;
  adjustmentPercentage: number;
}

export class EmployeePayParams implements CumulativeBonusIdInterface{
  employeeId: string;
  entityCode: string;
  enterpriseId: number;
  exportToPaySystem = DBStatus.ACTIVE;
  cumulativeBonusId1: number;
  cumulativeBonusId2: number;
  cumulativeBonusId3: number;
  cumulativeBonusId4: number;

  cumulativeBonusId5:number;
  cumulativeBonusId6:number;
  cumulativeBonusId7:number;
  cumulativeBonusId8:number;
  cumulativeBonusId9:number;
  cumulativeBonusId10:number;

  cumulativeBonusId11: number;
  cumulativeBonusId12: number;
  cumulativeBonusId13: number;
  cumulativeBonusId14: number;

  cumulativeBonusId15:number;
  cumulativeBonusId16:number;
  cumulativeBonusId17:number;
  cumulativeBonusId18:number;
  cumulativeBonusId19:number;
  cumulativeBonusId20:number;


  usableWageType: UsableWageType; // UsableWageType
  paymentMethod: PaymentModeType; // PaymentModeType

  bankId: string;
  bankTransit: string;
  bankAccount: string;
  payProvince= ProvinceCode.QUEBEC; // PayProvinceCode
  federalExemptionType: BaseFederalExemptionType ;    //
  provincialExemptionType: BaseProvincialExemptionType;  //
  exportEmployeeFile = DBStatus.ACTIVE;
  job: string;
  func: string;
  classe: string;
  workgroup: string;
  hourPerPay: number;
  jobStatus: JobStatusType ; // JobStatusType;
  displayPayCode = '003';
  fixedPay = false;

  _createSpecialElement(propertyName: string, data: any) {
    if ('payProvince' === propertyName) {
      this.payProvince = ProvinceStateCode.retrieveFromCode(data);
      return true;
    }
    if ('exportToPaySystem' === propertyName) {
      this.exportToPaySystem = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('exportEmployeeFile' === propertyName) {
      this.exportEmployeeFile = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('usableWageType' === propertyName) {
      this.usableWageType = UsableWageType.retrieveFromCode(data);
      return true;
    }
    if ('paymentMethod' === propertyName) {
      this.paymentMethod = PaymentModeType.retrieveFromCode(data);
      return true;
    }
    if ('federalExemptionType' === propertyName) {
      this.federalExemptionType = BaseFederalExemptionType.retrieveFromCode(data);
      return true;
    }
    if ('provincialExemptionType' === propertyName) {
      this.provincialExemptionType = BaseProvincialExemptionType.retrieveFromCode(data);
      return true;
    }
    if ('jobStatus' === propertyName) {
      this.jobStatus = JobStatusType.retrieveFromCode(data);
      return true;
    }


    return false;
  }

  public addDefaultBonus(toAdd: CumulativeBonus): boolean{
    const _helper = new JobBonusAndCumulativeBonusHelper();
    return _helper.addDefaultCumulativeBonus(this,toAdd);
  }


  public isCumulativeBonusDisabled(bonusId: number): boolean{
    const _helper = new JobBonusAndCumulativeBonusHelper();
    return _helper.isCumulativeBonusDisabled(this,bonusId);
  }


}

export class RemunerationAndBonusAggregation {

  employeeId: string;
  employeeFirstname = '';
  employeeFirstnamePreferred = '';
  employeeLastname = '';

  remuneration = new Remuneration();
  details = new Array<RemunerationDetail>();
  availableBonus = new Array<CumulativeBonus>();
  employeePayParams = new EmployeePayParams();
  cumulativeBonus = new Array<CumulativeBonus>();

  customCumulativePremiumConfigurationForEmployees = new Array<CustomPremiumConfigurationForEmployee>();


  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('details' === propertyName) {
      for (const bean of <RemunerationDetail[]> data) {
        const tmp = new RemunerationDetail();
        serializer.deserialize(bean, tmp);
        this.details.push(tmp);
      }
    }
    if ('availableBonus' === propertyName) {
      for (const bean of <CumulativeBonus[]> data) {
        const tmp = new CumulativeBonus();
        serializer.deserialize(bean, tmp);
        this.availableBonus.push(tmp);
      }
    }
    if ('cumulativeBonus' === propertyName) {
      for (const bean of <CumulativeBonus[]> data) {
        const tmp = new CumulativeBonus();
        serializer.deserialize(bean, tmp);
        this.cumulativeBonus.push(tmp);
      }
    }
    if ('customCumulativePremiumConfigurationForEmployees' === propertyName) {
      for (const bean of <CustomPremiumConfigurationForEmployee[]> data) {
        const tmp = new CustomPremiumConfigurationForEmployee();
        serializer.deserialize(bean, tmp);
        this.customCumulativePremiumConfigurationForEmployees.push(tmp);
      }
    }

  }

  get lastSalaryUpdate():Date | null{
    if (this.details && this.details.length>0){
      return moment(this.details[this.details.length-1].adjustingDt).toDate();
    }
    return null;
  }


  calculateCurrentSalary():number {
    let salary = 0;
      if (!Utils.isNullOrUndefined(this.remuneration)) {
        // this.startSalary = this.remunerationAndBonus.remuneration.startSalary;
        salary = this.remuneration.startSalary;
        for (const b of this.details) {
          if (moment(b.adjustingDt).isSameOrBefore(moment(),'day')){
            salary += b.adjustment;
          }
        }
      }
      return salary;
  }


}


export class CumulativeBonus {
 id: number;
 isDefault: boolean;
 name: string;
 note: string;
 type= CumulativeBonusType.OVERTIME;
 period = CumulativeBonusPeriod.HEBDO;
 workedHour = DBStatus.INACTIVE;

 // Careful in the java UI, those 2 elements have been inversed compared to the normal way of calling them..
  // I don't know if it's a bug or a feature... Annoying...
 training = DBStatus.INACTIVE;
 traineeship = DBStatus.INACTIVE;
  holiday = DBStatus.INACTIVE;
  bonus = DBStatus.INACTIVE;
  applyEvenOnHoliday = DBStatus.ACTIVE;

  applyToVacation = DBStatus.INACTIVE;
  applyToPaidDayOff = DBStatus.INACTIVE;
  applyToPaidSickDay = DBStatus.INACTIVE;
  applyToPaidAbsence = DBStatus.INACTIVE;
  applyToPaidDeath = DBStatus.INACTIVE;
  applyToPaidFamily = DBStatus.INACTIVE;
  displayBonusPartOnly = DBStatus.INACTIVE;

  applyOnMondays = DBStatus.ACTIVE;
  applyOnTuesdays = DBStatus.ACTIVE;
  applyOnWednesdays = DBStatus.ACTIVE;
  applyOnThursdays = DBStatus.ACTIVE;
  applyOnFridays = DBStatus.ACTIVE;
  applyOnSaturdays = DBStatus.ACTIVE;
  applyOnSundays = DBStatus.ACTIVE;

  useInSomeHolidayCalculation: boolean;

  condition = CumulativeBonusCondition.GREATER;
  conditionAmount: number;
  percent: number;
  amount: number;
  export: string;
  divisions: string;


  _createSpecialElement(propertyName: string, data: any) {
     if ('workedHour' === propertyName) {
       this.workedHour = DBStatus.retrieveFromCode(data);
       return true;
     }
    if ('training' === propertyName) {
      this.training = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('traineeship' === propertyName) {
      this.traineeship = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('holiday' === propertyName) {
      this.holiday = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyEvenOnHoliday' === propertyName) {
      this.applyEvenOnHoliday = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('applyToVacation' === propertyName) {
      this.applyToVacation = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyToPaidDayOff' === propertyName) {
      this.applyToPaidDayOff = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyToPaidSickDay' === propertyName) {
      this.applyToPaidSickDay = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyToPaidAbsence' === propertyName) {
      this.applyToPaidAbsence = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyToPaidDeath' === propertyName) {
      this.applyToPaidDeath = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyToPaidFamily' === propertyName) {
      this.applyToPaidFamily = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('bonus' === propertyName) {
      this.bonus = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('displayBonusPartOnly' === propertyName) {
      this.displayBonusPartOnly = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyOnMondays' === propertyName) {
      this.applyOnMondays = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyOnTuesdays' === propertyName) {
      this.applyOnTuesdays = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyOnWednesdays' === propertyName) {
      this.applyOnWednesdays = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyOnThursdays' === propertyName) {
      this.applyOnThursdays = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyOnFridays' === propertyName) {
      this.applyOnFridays = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyOnSaturdays' === propertyName) {
      this.applyOnSaturdays = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('applyOnSundays' === propertyName) {
      this.applyOnSundays = DBStatus.retrieveFromCode(data);
      return true;
    }


    if ('type' === propertyName) {
      this.type = CumulativeBonusType.retrieveFromCode(data);
      return true;
    }
    if ('period' === propertyName) {
      this.period = CumulativeBonusPeriod.retrieveFromCode(data);
      return true;
    }
    if ('condition' === propertyName) {
      this.condition = CumulativeBonusCondition.retrieveFromCode(data);
      return true;
    }
     return false;
  }


  containsUnitCode(code: string):boolean{
    if (Utils.isNullOrUndefined(this.divisions)){
      return false;
    }
    if (this.divisions.indexOf(code)>=0){
      return true;
    }
    return false;
  }


  listOfScheduleType(translate:TranslateService):string {
    let res = '';
    if (!Utils.isNullOrUndefined(this.workedHour)) {
      if (this.workedHour.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('CumulativeBonusWorkedHour');
      }
    }

    if (!Utils.isNullOrUndefined(this.training)) {
      if (this.training.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('CumulativeBonusTraining');
      }
    }
    // CumulativeBonusTraining = 'Entrainement';
    // CumulativeBonusTraineeship = 'Formation';


    if (!Utils.isNullOrUndefined(this.traineeship)) {
      if (this.traineeship.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('CumulativeBonusTraineeship');
      }
    }

    if (!Utils.isNullOrUndefined(this.holiday)) {
      if (this.holiday.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('CumulativeBonusHoliday');
      }
    }

    if (!Utils.isNullOrUndefined(this.applyToVacation)) {
      if (this.applyToVacation.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('CumulativeBonusVacation');
      }
    }

    if (!Utils.isNullOrUndefined(this.applyToPaidDayOff)) {
      if (this.applyToPaidDayOff.toBoolean) {
        if (res.length > 0) {
          res += ', '
        }
        res += translate.instant('CumulativeBonusPaidDayOff');
      }
    }


    return res;
  }


  get applyOnAllDaysOfTheWeek(){
    let res = true;
    if (DBStatus.INACTIVE === this.applyOnMondays){
      res = false;
    }
    if (DBStatus.INACTIVE === this.applyOnTuesdays){
      res = false;
    }
    if (DBStatus.INACTIVE === this.applyOnWednesdays){
      res = false;
    }
    if (DBStatus.INACTIVE === this.applyOnThursdays){
      res = false;
    }
    if (DBStatus.INACTIVE === this.applyOnFridays){
      res = false;
    }
    if (DBStatus.INACTIVE === this.applyOnSaturdays){
      res = false;
    }
    if (DBStatus.INACTIVE === this.applyOnSundays){
      res = false;
    }

    return res;
  }

  public retrieveListOfDays(translate: TranslateService): string{
    let tmp = '';
    if (DBStatus.ACTIVE === this.applyOnMondays){
      if (tmp.length>0){
        tmp += ', ';
      }

      tmp += translate.instant('MONDAY');
    }
    if (DBStatus.ACTIVE === this.applyOnTuesdays){
      if (tmp.length>0){
        tmp += ', ';
      }

      tmp += translate.instant('TUESDAY');
    }if (DBStatus.ACTIVE === this.applyOnWednesdays){
      if (tmp.length>0){
        tmp += ', ';
      }

      tmp += translate.instant('WEDNESDAY');
    }if (DBStatus.ACTIVE === this.applyOnThursdays){
      if (tmp.length>0){
        tmp += ', ';
      }

      tmp += translate.instant('THURSDAY');
    }if (DBStatus.ACTIVE === this.applyOnFridays){
      if (tmp.length>0){
        tmp += ', ';
      }

      tmp += translate.instant('FRIDAY');
    }
    if (DBStatus.ACTIVE === this.applyOnSaturdays){
      if (tmp.length>0){
        tmp += ', ';
      }

      tmp += translate.instant('SATURDAY');
    }
    if (DBStatus.ACTIVE === this.applyOnSundays){
      if (tmp.length>0){
        tmp += ', ';
      }

      tmp += translate.instant('SUNDAY');
    }
    return tmp;
  }


}



export  class CumulativeBonusType extends CustomCode {
  // OVERTIME ("0"),
  //   FIX ("1"),
  //   HOLIDAY("2");
  private static _registered = new Map<string, CumulativeBonusType>();
  static OVERTIME = new CumulativeBonusType('OVERTIME');
  static FIX = new CumulativeBonusType('FIX');
  static HOLIDAY = new CumulativeBonusType('HOLIDAY');


  static ALL = Array.from(CumulativeBonusType._registered.values());

  static retrieveFromCode(code: string): CumulativeBonusType {
    const res = CumulativeBonusType._registered.get(code);
    if (!res) {
      console.log('Hmmm CumulativeBonusType can\'t find ' + code);
    }
    return res;
  }

  constructor(code: string ) {
    super(code);
    CumulativeBonusType._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'CUMULATIVE_BONUS_TYPE_' + this.code;
  }
}

export  class CumulativeBonusPeriod extends CustomCode {
  // DAILY ("0"),
  // HEBDO ("1"),
  // FORTNIGHT ("2");
  private static _registered = new Map<string, CumulativeBonusPeriod>();
  static DAILY = new CumulativeBonusPeriod('DAILY');
  static HEBDO = new CumulativeBonusPeriod('HEBDO');
  static FORTNIGHT = new CumulativeBonusPeriod('FORTNIGHT');


  static ALL = Array.from(CumulativeBonusPeriod._registered.values());

  static retrieveFromCode(code: string): CumulativeBonusPeriod {
    const res = CumulativeBonusPeriod._registered.get(code);
    if (!res) {
      console.log('Hmmm CumulativeBonusPeriod can\'t find ' + code);
    }
    return res;
  }

  constructor(code: string ) {
    super(code);
    CumulativeBonusPeriod._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'CUMULATIVE_BONUS_PERIOD_' + this.code;
  }
}


export  class CumulativeBonusCondition extends CustomCode {
  // LESSER ("0"),
  // GREATER("1"),
  // EQUALS("2"),
  // DIFFERENT("3");
  // TO_A_MAX_OF("4");

  private static _registered = new Map<string, CumulativeBonusCondition>();
  static LESSER = new CumulativeBonusCondition('LESSER');
  static GREATER = new CumulativeBonusCondition('GREATER');
  static EQUALS = new CumulativeBonusCondition('EQUALS');
  static DIFFERENT = new CumulativeBonusCondition('DIFFERENT');
  static TO_A_MAX_OF = new CumulativeBonusCondition('TO_A_MAX_OF');
  static GREATER_OR_EQUALS = new CumulativeBonusCondition('GREATER_OR_EQUALS');

  

  // static ALL = Array.from(CumulativeBonusCondition._registered.values());
  static ALL = [CumulativeBonusCondition.LESSER,CumulativeBonusCondition.GREATER,CumulativeBonusCondition.EQUALS,CumulativeBonusCondition.DIFFERENT,CumulativeBonusCondition.GREATER_OR_EQUALS];
  static CUMULATIVE_AVAILABLE = [CumulativeBonusCondition.GREATER,CumulativeBonusCondition.LESSER,CumulativeBonusCondition.TO_A_MAX_OF];

  static retrieveFromCode(code: string): CumulativeBonusCondition {
    const res = CumulativeBonusCondition._registered.get(code);
    if (!res) {
      console.log('Hmmm CumulativeBonusCondition can\'t find ' + code);
    }
    return res;
  }

  constructor(code: string ) {
    super(code);
    CumulativeBonusCondition._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'CUMULATIVE_BONUS_CONDITION_' + this.code;
  }

}



export  class MinuteRemovalType extends CustomCode {


  private static _registered = new Map<string, MinuteRemovalType>();
  static AT_THE_END = new MinuteRemovalType('AT_THE_END');
  static AT_THE_BEGINNING = new MinuteRemovalType('AT_THE_BEGINNING');



   static ALL = Array.from(MinuteRemovalType._registered.values());

  static retrieveFromCode(code: string): MinuteRemovalType {
    const res = MinuteRemovalType._registered.get(code);
    if (!res) {
      console.log('Hmmm MinuteRemovalType can\'t find ' + code);
    }
    return res;
  }

  constructor(code: string ) {
    super(code);
    MinuteRemovalType._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'MINUTE_REMOVAL_TYPE_' + this.code;
  }

}


export class EmployeePunchParams {

  id: string;
  active = DBStatus.INACTIVE;
  activeWeb = DBStatus.INACTIVE;
  activeMobile = DBStatus.INACTIVE;
  badge = '';
  showBDate = DBStatus.INACTIVE;
  showSchedule = DBStatus.INACTIVE;
  showContact = DBStatus.INACTIVE;
  takePhoto = DBStatus.INACTIVE;
  canChangePositionOnSchedule = DBStatus.INACTIVE;
  canAddTimedTask = DBStatus.INACTIVE;
  multiTaskPermitted = DBStatus.ACTIVE;

  _createSpecialElement(propertyName: string, data: any) {
    if ('active' === propertyName) {
      this.active = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('activeWeb' === propertyName) {
      this.activeWeb = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('activeMobile' === propertyName) {
      this.activeMobile = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showBDate' === propertyName) {
      this.showBDate = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showSchedule' === propertyName) {
      this.showSchedule = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showContact' === propertyName) {
      this.showContact = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('takePhoto' === propertyName) {
      this.takePhoto = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('canChangePositionOnSchedule' === propertyName) {
      this.canChangePositionOnSchedule = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('canAddTimedTask' === propertyName) {
      this.canAddTimedTask = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('multiTaskPermitted' === propertyName) {
      this.multiTaskPermitted = DBStatus.retrieveFromCode(data);
      return true;
    }


    return false;
  }
}


export class EmployeePortalParams {

  id: string;
  showInfos = DBStatus.INACTIVE;
  showBanks = DBStatus.INACTIVE;
  showClassicTimeBank = DBStatus.ACTIVE;
  showSickDaysBank = DBStatus.ACTIVE;
  showEmployeeSchedules = DBStatus.INACTIVE;
  showDivisionSchedules = DBStatus.INACTIVE;
  showDivisionSchedulesWithSamePosition = DBStatus.INACTIVE;
  showTimeSheets = DBStatus.INACTIVE;
  showMessages = DBStatus.INACTIVE;
  showPayStubs = DBStatus.INACTIVE;

  canAddExpenses = DBStatus.INACTIVE;
  canModifyOwnProfile=DBStatus.INACTIVE;


  _createSpecialElement(propertyName: string, data: any) {
    if ('showInfos' === propertyName) {
      this.showInfos = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showBanks' === propertyName) {
      this.showBanks = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showClassicTimeBank' === propertyName) {
      this.showClassicTimeBank = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showSickDaysBank' === propertyName) {
      this.showSickDaysBank = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('showEmployeeSchedules' === propertyName) {
      this.showEmployeeSchedules = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showDivisionSchedules' === propertyName) {
      this.showDivisionSchedules = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('showDivisionSchedulesWithSamePosition' === propertyName) {
      this.showDivisionSchedulesWithSamePosition = DBStatus.retrieveFromCode(data);
      return true;
    }

    if ('showTimeSheets' === propertyName) {
      this.showTimeSheets = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showMessages' === propertyName) {
      this.showMessages = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('showPayStubs' === propertyName) {
      this.showPayStubs = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('canAddExpenses' === propertyName) {
      this.canAddExpenses = DBStatus.retrieveFromCode(data);
      return true;
    }
    if ('canModifyOwnProfile' === propertyName) {
      this.canModifyOwnProfile = DBStatus.retrieveFromCode(data);
      return true;
    }


    return false;
  }
}


export class PunchAndPortalParameters {
  employeeId: string;
  employee = new Employee();
  punchParams = new EmployeePunchParams();
  user = new User();
  portalParams = new EmployeePortalParams();

  securityPerUser = new SecurityPerUser();
  securityPerEnterprise = new SecurityPerEnterprise();

  userPreferences = new Array<UserPreference>();

  employeeNotificationConfiguration = new EmployeeNotificationConfiguration();

  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('userPreferences' === propertyName) {
      for (const bean of <UserPreference[]>data) {
        const tmp = new UserPreference();
        serializer.deserialize(bean, tmp);
        this.userPreferences.push(tmp);
      }
    }
  }

  public findOrCreate(pref: PrefName):UserPreference{
      for (const bean of this.userPreferences){
        if (pref === bean.prefName){
          return bean;
        }
      }
      const res= new UserPreference();
      res.prefName = pref;
      res.username = this.user.username;
      res.prefValue='N';
      res.prefType = PrefType.BOOLEAN;
      this.userPreferences.push(res);
      return res;
  }


}


export class EmployeePrefAppel {

  id: string;
  pref1: PreferenceAppel;
  pref2: PreferenceAppel;
  pref3: PreferenceAppel;

  _createSpecialElement(propertyName: string, data: any) {
    if ('pref1' === propertyName) {
      this.pref1 = PreferenceAppel.retrieveFromCode(data);
      return true;
    }
    if ('pref2' === propertyName) {
      this.pref2 = PreferenceAppel.retrieveFromCode(data);
      return true;
    }
    if ('pref3' === propertyName) {
      this.pref3 = PreferenceAppel.retrieveFromCode(data);
      return true;
    }

    return false;
  }

}

export class AbsencesAggregation {
  employeeId: string;
  seniorityDate: Date;
  sickDays = new Array<EmployeeSickDays>();
  vacations = new Array<EmployeeVacation>();
  familyDays = new Array<EmployeeFamilyDays>()

  workCodeData = new WorkCodeData();
  canSeeAmount = false;
  canEdit = false;
  bankTypeEmployees = new Array<BankTypeEmployee>();
  currentWage : number;


  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('sickDays' === propertyName) {
      for (const bean of <EmployeeSickDays[]> data) {
        const tmp = new EmployeeSickDays();
        serializer.deserialize(bean, tmp);
        this.sickDays.push(tmp);
      }
    }
    if ('familyDays' === propertyName) {
      for (const bean of <EmployeeFamilyDays[]> data) {
        const tmp = new EmployeeFamilyDays();
        serializer.deserialize(bean, tmp);
        this.familyDays.push(tmp);
      }
    }
    if ('vacations' === propertyName) {
      for (const bean of <EmployeeVacation[]> data) {
        const tmp = new EmployeeVacation();
        serializer.deserialize(bean, tmp);
        this.vacations.push(tmp);
      }
    }
    if ('bankTypeEmployees' === propertyName) {
      for (const bean of <BankTypeEmployee[]> data) {
        const tmp = new BankTypeEmployee();
        serializer.deserialize(bean, tmp);
        this.bankTypeEmployees.push(tmp);
      }
    }
  }

  doWeHaveAVacationWithDifferentIdAndSameStartingDate(id:number, periodStartDt: Date):boolean{
    if (!Utils.isNullOrUndefined(periodStartDt)){
      for (const vacation of this.vacations){
        // console.log('vacation.id: ' + vacation.id + ' '+ id );
        if (vacation.id !== id){
          // console.log('vacation.period: ' + periodStartDt + ' '+ vacation.periodStartDt );
          if (Math.abs(Utils.diffDateInDays(periodStartDt,vacation.periodStartDt))<=0){
            return true;
          }
        }
      }
    }
    return false;
  }

  retrieveOneOfTheVacationsStartingTheSameDate(): EmployeeVacation{
    for (const vacation of this.vacations){
        let res = this.doWeHaveAVacationWithDifferentIdAndSameStartingDate(vacation.id,vacation.periodStartDt);
        if (res === true){
          return vacation;
        }
    }
    return null;
  }

  retrieveLastVacation():EmployeeVacation | null{
    if (this.vacations && this.vacations.length>0){
      const vacations = this.vacations.sort((d1,d2)=>{
        let res = 0;
        if (Utils.isAfterRefDate(d1.periodStartDt,d2.periodStartDt)){
          res = 1;
        }else if (Utils.isAfterRefDate(d1.periodStartDt,d2.periodStartDt)){
          res = -1;
        }
        return res;
      });
      // console.log('Vacations: ', vacations);
      // console.log('WAS this.vacations:',this.vacations);
      return vacations[0];
    }
    return null;
  }


}

export class EmployeeSickDays {
  id: number;
  employeeId: string;
  startDate: Date;
  endDate: Date;
  nbMin: number;
  nbUsed: number;


  public inRightPeriod(dtRef: Date):boolean{
    if (Utils.isNullOrUndefined(this.startDate) || Utils.isNullOrUndefined(this.endDate) || Utils.isNullOrUndefined(dtRef)){
      return true;
      // return this.active;
    }
    if (Utils.isAfterRefDate(dtRef,this.startDate)){
      if (Utils.isBeforeRefDate(dtRef,this.endDate)){
        return true;
      }
    }
    return false;
  }


}

export class EmployeeVacation {
   id: number;
   employeeId: string;
   periodStartDt: Date;
   periodEndDt: Date;
   vacationPercentage = 0;
   vacationInDays = 0;
   accumulatedAmount = 0;
   aheadDay = 0;
   aheadAmount = 0;
   deferredDay = 0;
   deferredAmount = 0;
   nbDayUsed=0;
   usedAmount = 0;

   vimInitialMinutes = 0;
   vimBalanceMinutes = 0;
   vimAverageRate=0;
  vimDayOfVacationInMinutes = 0;
  lastUpdateDt: Date;


   static retrieveLastVacation(all: EmployeeVacation[], refDate: Date): EmployeeVacation {
    let res: EmployeeVacation;
    if (all) {
      let min = Number.MAX_SAFE_INTEGER;
      for (const one of all){
        if (one.periodEndDt) {
          const diff = Utils.diffDateInDays(refDate,one.periodEndDt);
          //const diff = moment(refDate).diff(moment(one.periodEndDt));
          // console.log('diff: ' + diff + ' ' + moment(one.periodEndDt).format('LL') + ' ref: ' + moment(refDate).format('LL'));
           if (diff >= 0) {
             if (min > diff) {
               min = diff;
               res = one;
             }
           }
        }
      }
    }
    return res;
  }

  static retrievePreviousVacationPeriod(all: EmployeeVacation[], refDate: Date): EmployeeVacation {
    let res: EmployeeVacation;
    if (all) {
      let min = Number.MIN_SAFE_INTEGER;
      for (const one of all){
        if (one.periodEndDt) {
          const diff = Utils.diffDateInDays(refDate,one.periodEndDt);
          //const diff = moment(refDate).diff(moment(one.periodEndDt));
          // console.log('diff: ' + diff + ' ' + moment(one.periodEndDt).format('LL') + ' ref: ' + moment(refDate).format('LL'));
          if (diff<=0){
            if (min<diff){
              min = diff;
              res = one;
            }
          }
          /*
          if (diff >= 0) {
            if (min > diff) {
              min = diff;
              res = one;
            }
          }

           */
        }
      }
    }
    return res;
  }


  public get leftDays(){
    return this.vacationInDays + this.aheadDay - this.deferredDay - this.nbDayUsed;
  }
  public get leftAmount(){
    return this.accumulatedAmount + this.aheadAmount - this.deferredAmount - this.usedAmount;
  }


  public inRightPeriod(dtRef: Date):boolean{
    if (Utils.isNullOrUndefined(this.periodStartDt) || Utils.isNullOrUndefined(this.periodEndDt) || Utils.isNullOrUndefined(dtRef)){
      return true;
      // return this.active;
    }
    if (Utils.isAfterRefDate(dtRef,this.periodStartDt)){
      if (Utils.isBeforeRefDate(dtRef,this.periodEndDt)){
        return true;
      }
    }
    return false;
  }

}

export class EmployeeJobAggregation {
  employeeId: string;
  employee = new Employee();
  employeeJobs = new Array<EmployeeJob>();
  jobBonuses = new Array<JobBonus>();
  /** contains all available jobs with its associated unit */
  availableJobWithUnit = new Array<JobAndUnitInfo>();
  divisions = new Array<Unit>();
  ccqConfigurationForEmployee = new CCQConfigurationForEmployee();

  // payingEnterpriseUsesJobSegment = false;
  enterprise = new Enterprise();
  enterpriseCostDistributionConfigs = new Array<EnterpriseCostDistributionConfig>();


  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('employeeJobs' === propertyName) {
      for (const bean of <EmployeeJob[]> data) {
        const tmp = new EmployeeJob();
        serializer.deserialize(bean, tmp);
        this.employeeJobs.push(tmp);
      }
    }
    if ('jobBonuses' === propertyName) {
      for (const bean of <JobBonus[]> data) {
        const tmp = new JobBonus();
        serializer.deserialize(bean, tmp);
        this.jobBonuses.push(tmp);
      }
    }
    if ('availableJobWithUnit' === propertyName) {
      for (const bean of <JobAndUnitInfo[]> data) {
        const tmp = new JobAndUnitInfo();
        serializer.deserialize(bean, tmp);
        this.availableJobWithUnit.push(tmp);
      }
    }
    if ('divisions' === propertyName) {
      for (const bean of <Unit[]> data) {
        const tmp = new Unit();
        serializer.deserialize(bean, tmp);
        this.divisions.push(tmp);
      }
    }
    if ('enterpriseCostDistributionConfigs' === propertyName) {
      for (const bean of <EnterpriseCostDistributionConfig[]> data) {
        const tmp = new EnterpriseCostDistributionConfig();
        serializer.deserialize(bean, tmp);
        this.enterpriseCostDistributionConfigs.push(tmp);
      }
    }
  }

  public get isCCQ(){
    if (this.ccqConfigurationForEmployee){
      return this.ccqConfigurationForEmployee.active;
    }
    return false;
  }

  public get isAtLeastOneActiveAndDefaultJob(): boolean{
    let foundActive = false;
    let foundDefaultActive = false;
    for (const bean of this.employeeJobs){
      if (bean.isActive){
        foundActive = true;
        if (bean.defaultJob){
          if (foundDefaultActive===false){
            foundDefaultActive = true;
          }else{
            return false;
          }
        }
      }
    }
    // if (foundActive===false){
    //   res += ' ' +  this.translate.instant('AtLeastOneJobMustBeActive');
    // }
    if (foundDefaultActive===false){
      return false;
      // res += ' ' +  translate.instant('AtLeastOneJobMustBeActiveAndDefault');
    }
    return true;
  }

  public getJobAndUnitInfo(includeInactive:false){
    const res = new Array<JobAndUnitInfo>();
    for (const bean of this.employeeJobs){
      if (includeInactive===false){
        if (!bean.isActive){
          continue;
        }
      }
      const tmp = new JobAndUnitInfo();
      tmp.job = new JobInfo();
      tmp.job.jobId = bean.jobId;
      tmp.job.description = bean.jobLabel;
      tmp.unit = new Unit();
      tmp.unit.unitCode = bean.unitId;
      tmp.unit.description = bean.unitDescription;
      res.push(tmp);
    }
    return res;
  }


  explainJobActive(sanitizer: DomSanitizer, translate: TranslateService):SafeHtml{
    let res  = '';
    let foundActive = false;
    let foundDefaultActive = false;
    for (const bean of this.employeeJobs){
      if (bean.isActive){
        foundActive = true;
        if (bean.defaultJob){
          if (foundDefaultActive===false){
            foundDefaultActive = true;
          }else{
            res += translate.instant('OnlyOneJobMustBeDefault');
          }
        }
      }
    }
    // if (foundActive===false){
    //   res += ' ' +  this.translate.instant('AtLeastOneJobMustBeActive');
    // }
    if (foundDefaultActive===false){
      res += ' ' +  translate.instant('AtLeastOneJobMustBeActiveAndDefault');
    }

    return sanitizer.bypassSecurityTrustHtml(res);
  }

}


export class EmployeePayParamsAggregation {
    employeeId: string;
    employeeFullName: string;
    payParams = new EmployeePayParams();
    scheduleParams = new EmployeeScheduleParams();
    timesheetParams = new EmployeeTimesheetParams();
    availableEnterprises = new Array<Enterprise>();


  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('availableEnterprises' === propertyName) {
      for (const bean of <Enterprise[]> data) {
        const tmp = new Enterprise();
        serializer.deserialize(bean, tmp);
        this.availableEnterprises.push(tmp);
      }
    }
  }

}


export class EmployeeScheduleParams {
  employeeId: string;
  sortOrder: number;
  defaultUnits: string;
  defaultSort: number;
  defaultEmployee: string;
  canModifyAvailability: boolean=false;
  canRequestVacation: boolean=false;
  canExchangeShift: boolean=false;
  canRequestBankType :boolean=false;
}

export class EmployeeTimesheetParams {
   employeeId: string;
   graceStartBefore = 30;
   graceStartAfter= 15;
   graceEndBefore = 15;
   graceEndAfter = 5;
   graceMealShorter = 10;
   graceMealLonger = 10;
   gracePause = 1;
   roundingStartBefore = 1;
   roundingStartAfter = 1;
   roundingEndBefore = 1;
   roundingEndAfter = 1;
   roundingStartNoSchedule = 1;
   roundingEndNoSchedule = 1;
   roundingMeal = 1;
   roundingPause = 1;
   roundingStartBeforeMode = HoraireRoundingMode.HALF_UP;
  roundingStartAfterMode = HoraireRoundingMode.HALF_UP;
  roundingEndBeforeMode = HoraireRoundingMode.HALF_UP;
  roundingEndAfterMode = HoraireRoundingMode.HALF_UP;
  roundingStartNoScheduleMode = HoraireRoundingMode.HALF_UP;

  roundingEndNoScheduleMode = HoraireRoundingMode.HALF_UP;
  roundingMealMode = HoraireRoundingMode.HALF_UP;
  roundingPauseMode = HoraireRoundingMode.HALF_UP;
  pauseDuration = 15;
  holidayCalculationType = HolidayCalculationType.ONE_TWENTY_FOUR_PAY;
  holidayMinutes: number;
  mealDurationType = MealDurationType.PUNCH_DURATION;
  mealDurationMinutes = 30;
  breaksArePaidEvenWhenNotScheduled = true;
  alwaysPayMeals = false;
  neverPayMeals = false;
  holidayAlternateExportCode: string;
  useHolidayAlternateExportCode = false;
  holidayMaxMinutes = 0;
  autoAttendance = false;

  familyDaysCalculationType = HolidayCalculationType.ONE_TWENTY_FOUR_PAY;
  familyDaysMinutes: number;
  familyDaysAlternateExportCode = '';
  useFamilyDaysAlternateExportCode = false;
  familyDaysMaxMinutes = 0;


  _createSpecialElement(propertyName: string, data: any) {
    if ('roundingStartBeforeMode' === propertyName) {
      this.roundingStartBeforeMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }
    if ('roundingStartAfterMode' === propertyName) {
      this.roundingStartAfterMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }
    if ('roundingEndBeforeMode' === propertyName) {
      this.roundingEndBeforeMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }
    if ('roundingEndAfterMode' === propertyName) {
      this.roundingEndAfterMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }
    if ('roundingStartNoScheduleMode' === propertyName) {
      this.roundingStartNoScheduleMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }
    if ('roundingEndNoScheduleMode' === propertyName) {
      this.roundingEndNoScheduleMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }
    if ('roundingMealMode' === propertyName) {
      this.roundingMealMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }
    if ('roundingPauseMode' === propertyName) {
      this.roundingPauseMode = HoraireRoundingMode.retrieveFromCode(data);
      return true;
    }

    if ('familyDaysCalculationType' === propertyName) {
      this.familyDaysCalculationType = HolidayCalculationType.retrieveFromCode(data);
      return true;
    }
    if ('mealDurationType' === propertyName) {
      this.mealDurationType = MealDurationType.retrieveFromCode(data);
      return true;
    }
    if ('holidayCalculationType' === propertyName) {
      this.holidayCalculationType = HolidayCalculationType.retrieveFromCode(data);
      return true;
    }


    return false;
  }
}
